'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';

import { useDatadogReady } from '@/auth-src/contexts/DatadogReadyContext';

export function DatadogUserIdentify() {
  const { data: session } = useSession();
  const isReady = useDatadogReady();

  useEffect(() => {
    if (!isReady) return;

    if (session?.user) {
      datadogRum.setUser({
        id: session.user.id,
        email: session.user.email ?? undefined,
        name: session.user.name ?? undefined,
      });
    } else {
      datadogRum.clearUser();
    }
  }, [session, isReady]);

  return null;
}
